//import statement
import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import Icon1 from "../assets/icon1.png";
import Icon2 from "../assets/icon2.png";
import Icon3 from "../assets/icon3.png";

//functional component
const InfoBar = ({ tickets, spent, wallets }) => {
  return (
    <Row className="info-bar">
      <Col md="4" className="text-center mx-auto ">
        <div className="icon_content">
          <img className="m-3" src={Icon1} height={30} width={30} />
          Tickets sold: {tickets}
        </div>
      </Col>
      <Col md="4" className="text-center mx-auto">
        <div className="icon_content">
          <img className="m-3" src={Icon2} height={30} width={40} />
          $GOD spent: {spent}
        </div>
      </Col>
      <Col md="4" className="text-center mx-auto">
        <div className="icon_content">
          <img className="m-3" src={Icon3} height={30} width={30} />
          Unique wallets: {wallets}
        </div>
      </Col>
    </Row>
  );
};
export default InfoBar;
